import { __ } from '@wordpress/i18n';

export const MIN_YEAR = 2024;

/**
 * Year picker (<select>) limited to MIN_YEAR..current year. Browsers have no
 * year-only date input, so a dropdown is the closest equivalent. Exposes the
 * same `.value` API as an <input>; a stored year outside the range (legacy
 * data) is appended on assignment so editing it doesn't blank the field.
 */
export function createYearSelect( className ) {
	const select = document.createElement( 'select' );
	select.className = className;

	const placeholder = document.createElement( 'option' );
	placeholder.value = '';
	placeholder.textContent = __( 'Year', 'anacrm' );
	select.appendChild( placeholder );

	const last = Math.max( new Date().getFullYear(), MIN_YEAR );
	for ( let y = last; y >= MIN_YEAR; y-- ) {
		const opt = document.createElement( 'option' );
		opt.value = String( y );
		opt.textContent = String( y );
		select.appendChild( opt );
	}

	const desc = Object.getOwnPropertyDescriptor(
		HTMLSelectElement.prototype,
		'value'
	);
	Object.defineProperty( select, 'value', {
		get() {
			return desc.get.call( this );
		},
		set( v ) {
			const val = v === null || v === undefined ? '' : String( v );
			if (
				val &&
				! Array.from( this.options ).some( ( o ) => o.value === val )
			) {
				const opt = document.createElement( 'option' );
				opt.value = val;
				opt.textContent = val;
				this.appendChild( opt );
			}
			desc.set.call( this, val );
		},
	} );

	return select;
}
